<div class="flex h-screen bg-gray-100 font-sans text-sm">
  <!-- Left Sidebar (Inbox) -->
  <aside class="w-64 bg-white border-r flex flex-col p-4 space-y-4">
    <app-left-sidebar></app-left-sidebar>
  </aside>

  <!-- Main Content -->
  <main class="flex-1 flex flex-col bg-purple-50 overflow-y-auto">
    <header class="p-4 border-b bg-white">
      <h1 class="text-xl font-bold text-purple-800">Pošalji kao klijent</h1>
      <p class="text-xs text-gray-500 mt-1">Ručni unos poruke koja stiže od klijenta</p>
    </header>

    <div class="flex-1 p-6">
      <section class="bg-white border rounded-xl shadow-sm overflow-hidden max-w-xl">
        <div class="px-5 py-4 border-b">
          <h2 class="font-bold text-purple-700">Podaci o poruci</h2>
        </div>

        <form [formRoot]="messageForm" class="px-5 py-4 space-y-3">
          <div class="flex flex-col gap-1">
            <label class="text-xs font-bold uppercase text-gray-500">Prefix</label>
            <select
              class="w-full border rounded-lg p-2 bg-white focus:ring-2 focus:ring-purple-500 outline-none"
              [class.border-red-500]="messageForm.prefixId().invalid() && messageForm.prefixId().touched()"
              [value]="model().prefixId"
              (change)="updatePrefixId($event)"
            >
              <option value="0">Izaberi prefix</option>
              @for (prefix of prefixes(); track prefix.id) {
                <option [value]="prefix.id">{{ prefix.prefix_code }}</option>
              }
            </select>
            @if (messageForm.prefixId().invalid() && messageForm.prefixId().touched()) {
              <p class="text-xs text-red-600">Izaberi prefix.</p>
            }
          </div>

          <div class="flex flex-col gap-1">
            <label class="text-xs font-bold uppercase text-gray-500">Provider kod</label>
            <select
              class="w-full border rounded-lg p-2 bg-white focus:ring-2 focus:ring-purple-500 outline-none"
              [class.border-red-500]="messageForm.providerCodeId().invalid() && messageForm.providerCodeId().touched()"
              [value]="model().providerCodeId"
              [disabled]="!model().prefixId"
              (change)="updateProviderCodeId($event)"
            >
              <option value="0">Izaberi provider kod</option>
              @for (code of filteredProviderCodes(); track code.id) {
                <option [value]="code.id">{{ code.code }}</option>
              }
            </select>
            @if (messageForm.providerCodeId().invalid() && messageForm.providerCodeId().touched()) {
              <p class="text-xs text-red-600">Izaberi provider kod.</p>
            }
          </div>

          <div class="flex flex-col gap-1">
            <label class="text-xs font-bold uppercase text-gray-500">Telefon</label>
            <input
              type="text"
              placeholder="Unesi broj telefona..."
              class="w-full border rounded-lg p-2 focus:ring-2 focus:ring-purple-500 outline-none"
              [formField]="messageForm.phoneNumber"
            />
          </div>

          <div class="flex flex-col gap-1">
            <label class="text-xs font-bold uppercase text-gray-500">Identitet</label>
            <input
              type="text"
              placeholder="Unesi ime/identitet (opciono)..."
              class="w-full border rounded-lg p-2 focus:ring-2 focus:ring-purple-500 outline-none"
              [formField]="messageForm.identity"
            />
          </div>

          <div class="flex flex-col gap-1">
            <label class="text-xs font-bold uppercase text-gray-500">Provider broj</label>
            <input
              type="text"
              placeholder="Unesi provider broj (npr. 5544)..."
              class="w-full border rounded-lg p-2 focus:ring-2 focus:ring-purple-500 outline-none"
              [formField]="messageForm.providerNumber"
            />
          </div>

          <div class="flex flex-col gap-1">
            <label class="text-xs font-bold uppercase text-gray-500">Poruka</label>
            <textarea
              rows="4"
              placeholder="Unesi tekst poruke..."
              class="w-full border rounded-lg p-2 focus:ring-2 focus:ring-purple-500 outline-none resize-none"
              [formField]="messageForm.message"
            ></textarea>
          </div>

          <button
            class="w-full px-8 py-2 bg-purple-600 text-white rounded-lg font-bold hover:bg-purple-700 transition-colors"
            type="submit"
          >
            Pošalji poruku
          </button>
        </form>
      </section>
    </div>
  </main>
</div>
